
<template>
  <div class="bg-cream">
    <Nav color="blue" :init-banner-state="false"></Nav>
    <section id="tosola" class="padding-main">
      <div>
        <div id="title-block" class="row mb-6 gap-3 space-between container-large">
          <div class="basis-65-gap-1">
            <img class="card" src="../../assets/img/landing-pages/tosola/TOSOLA_hero.png">
          </div>
          <div id="app-info-container" class="col basis-30-gap-3">
            <img id="icon-click" src="@/assets/img/landing-pages/ICON_app-click_green.png">
            <CompanionAppHighlight app-name="Tosola" class="border-green" color="green"></CompanionAppHighlight>
            <button class="dark-green full disabled" @click="pushAppRedirect()">Download the app</button>
            <button class="outline light-green full" @click="pushStorePageRedirect()">Purchase the game</button>
          </div>
        </div>
        <div id="highlights" class="bg-light-green">
          <div class="container-mid">
            <h2 class="green mb-2 centered">A narrative adventure for the whole family!</h2>
            <div class="row gap-3 container green justify-content-center">
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_CLUES.png">
                <p><strong>Gather clues</strong> and <br>solve puzzles</p>
              </div>
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_NATURE.png">
                <p>Full of fun <br><strong>nature facts</strong></p>
              </div>
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_SOLO.png">
                <p>Play <strong>solo</strong> or <br>as a <strong>group</strong></p>
              </div>
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_COMIC_AR.png">
                <p>A story told through <br><strong>comics & augmented reality</strong></p>
              </div>
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_CHAPTERS.png">
                <p>A story in <br><strong>3 chapters, 1h+ each</strong></p>
              </div>
              <div class="highlight-item">
                <img src="@/assets/img/landing-pages/tosola/TS_ICON_CRITTERS.png">
                <p>A story about<br><strong>caring for the little critters</strong></p>
              </div>
            </div>
          </div>
        </div>
        <div id="support-creativebc" class="bg-green mb-4">
          <div class="container-mid centered col">
            <h5 class="uppercase small-text cream mb-2">Developed with the participation of Creative BC and the British Columbia Arts Council</h5>
            <img src="../../assets/img/landing-pages/tosola/CreativeBC-BCID-ArtsCouncil-lockup_rgb_rev.png">
          </div>
        </div>
        <div id="about-story">
          <div class="container-large">
            <h2 class="green centered">About the story</h2>
            <div class="col align-items-center centered">
              <p>Strange things are happening in Tosola.</p>
              <img src="@/assets/img/landing-pages/tosola/STORY_cards.png">
              <p >Plants are turning to stone,<br>
                and Nika’s garden plot has been ransacked.</p>
              <img src="@/assets/img/landing-pages/tosola/STORY_comic.png">
              <p>Her granddaughter, Blueberry, <br>
                sets out to investigate what happened.</p>
              <img src="@/assets/img/landing-pages/tosola/STORY_app.png">
              <p>As she digs deeper, she uncovers the town’s hidden truths, <br>
                encounters ancestral creatures, <br>and works to restore balance to the community.</p>
              <img src="@/assets/img/landing-pages/tosola/STORY_spirits.png">
            </div>
          </div>
        </div>
        <TosolaConcept></TosolaConcept>
        <div id="benefits">
          <div class="grid grid-4 container-large">
            <div class="benefit-item">
              <img src="@/assets/img/landing-pages/tosola/ICON_CROSSMEDIA.png">
              <p>A <strong>cross-media</strong><br> narrative game</p>
            </div>
            <div class="benefit-item">
              <img src="@/assets/img/landing-pages/tosola/ICON_NO-AI.png">
              <p>No generative AI:<br><strong>crafted by real humans</strong></p>
            </div>
            <div class="benefit-item">
              <img src="@/assets/img/landing-pages/tosola/ICON_AGE_TOSOLA.png">
              <div>
                <p class="no-pb">Best for<br><strong>ages 7 to 12</strong></p>
                <p class="note">(enjoyed by the whole family)</p>
              </div>
            </div>
            <div class="benefit-item">
              <img src="@/assets/img/landing-pages/tosola/ICON_CANADA.png">
              <p>Designed in<br><strong>Squamish, BC</strong></p>
            </div>
          </div>

        </div>
        <div class="container-large">
          <div id="in-the-box">
            <div class="card-container-outline border-green">
              <div class="inner-padding">
                <h2 class="bottom-line green">In the box</h2>
                <div class="grid grid-2">
                  <div class="box-item">
                    <img src="@/assets/img/landing-pages/tosola/BOX_characters.png">
                    <p>9 starting character cards</p>
                  </div>
                  <div class="box-item">
                    <img src="@/assets/img/landing-pages/tosola/BOX_book.png">
                    <p>100-page comic book</p>
                  </div>
                  <div class="box-item">
                    <img src="@/assets/img/landing-pages/tosola/BOX_clues.png">
                    <p>46 clues cards</p>
                  </div>
                  <div class="box-item">
                    <img src="@/assets/img/landing-pages/tosola/BOX_rulesheet.png">
                    <p>1 rule sheet</p>
                  </div>
                </div>
              </div>
              <div id="app-reminder" class="col bg-light-green align-items-center">
                <p class="centered mt-1 mb-1">Our free companion app TOSOLA is required to play the game.</p>
                <div id="app-info-container" class="col width-50">
                  <CompanionAppHighlight app-name="Tosola" class="bg-cream border-green" color="green"></CompanionAppHighlight>
                </div>
              </div>
            </div>
          </div>
        </div>
        <StoreFeaturedProducts class="mb-4"></StoreFeaturedProducts>
      </div>
    </section>
    <SmallPreFooter></SmallPreFooter>
    <Footer :borderTop=false></Footer>
  </div>
</template>

<script>
import router from "@/router/index.js";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import TosolaConcept from "@/components/ProductSpecific/TosolaConcept.vue";
import StoreFeaturedProducts from "@/components/StoreFeaturedProducts.vue";
import CompanionAppHighlight from "@/components/CompanionAppHighlight.vue";
import SmallPreFooter from "@/components/SmallPreFooter.vue";

export default {
  name: 'Tosola',
  components: {
    SmallPreFooter,
    CompanionAppHighlight,
    StoreFeaturedProducts,
    TosolaConcept,
    Footer,
    Nav
  },
  data () {
    return {
    }
  },
  methods: {
    pushStorePageRedirect() {
      router.push('/product/the-mysteries-of-tosola')
    },
    pushAppRedirect() {
      router.push(this.$store.getAppRedirectByName('tosola'));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables";

#tosola {
  position: relative;
}

#app-info-container {
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  max-width: 500px;
}

#highlights {
  padding: 8em 0;
  border-top: 1px solid $tosola-dark-green;
  border-bottom: 1px solid $tosola-dark-green;

  .highlight-item {
    margin-top: 1em;
  }

  .highlight-item img{
    max-width: 60%;
  }
}

#support-creativebc {
  padding: 3em 0 2em 0;
}

#title-block {

  .basis-65-gap-1 {
    flex-grow: 1;
  }

  h2 {
    font-weight: normal;
    font-size: 1.5em;
  }

  #icon-click {
    max-width: 240px;
  }

  #product-shot-hero {
    height: auto;
    max-width: 230px;

    img {
      border-radius: 40px;
    }

  }

  #product-text-block {
    margin-left: 200px;
    margin-top: -120px;

    h1 {
      font-size: 3em;
      padding-bottom: 0.1em;
    }
  }

  button {
    margin: 0 0 1em 0;
    //width: 80%;
  }

}

#about-story {
  padding: 4em 0;
  p {
    font-size: 1.4em;
    line-height: 175%;
    margin: 2em 0;
  }

  img {
    max-width: 80%;
  }
}

#in-the-box {
  #app-reminder {
    border-radius: 0 0 20px 20px;
    border-top: 1px solid $tosola-dark-green;
    padding: 1em 0;
  }

  .card-container-outline {
    padding: 0;
    margin: 0;
  }
  .inner-padding {
    padding: 3em;
  }

  #app-block.card-container-outline {
    padding: .5em;
  }

  .box-item {
    text-align: center;

    img {
      max-width: 80%;
    }
  }

  .image-container {
    max-width: 100px;
  }
}


@media only screen and (max-width: 1200px) {
  #title-block {
    justify-content: center;
    gap: 3em;

    .left {
      display: flex;
      flex-direction: row;
      flex-basis: fit-content;
    }

    #icon-click {
      max-width: 100px;
    }


    #product-text-block {
      margin-left: -2em;
      margin-top: 6em;
    }

    .right {
      flex-basis: fit-content;
    }

    #app-block {
      img.app-icon {
        max-width: 100px;
      }
    }
  }
}


@media only screen and (max-width: 747px) {

  #title-block {
    justify-content: center;
    gap: 1em;

    .left, .right {
      flex-basis: unset;
      flex-direction: column;
    }

    #product-shot-hero {
      width: 40vw;
      border-radius: 30px;
      max-width: 220px;
      height: auto;
    }

    #product-text-block {
      margin-left: 13vw;
      margin-top: -1.8em;

      h1 {
        font-size: 2.5em;
        padding-bottom: 0.1em;
      }

      h2 {
        font-size: 1em;
      }
    }

    #app-block {
      align-items: center;

      img.app-icon {
        max-width: 80px;
      }

      .tag {
        font-size: .9em;
      }

      a {
        font-size: 0.9em;
      }
    }
  }


  #benefits {
    margin: 3em 0px 3em 0px;

    &.grid.grid-4 {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  #abt-story {
    .background-visual {
      min-height: 400px;
    }
  }

  #abt-story-block {
    border: 1px solid $blue;
    max-width: 100%;
    margin: -6em 0px 0px 0px;
  }

  #video-block iframe.card {
    border-radius: 20px;
  }

  #in-the-box {
    #app-reminder {
      .width-50 {
        width: unset;
        margin: .5em 2em;
        max-width: 90vw;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
  #title-block {
    #product-shot-hero {
      height: auto;
      max-width: 250px;
      border-radius: 40px;
    }

    #product-text-block {
      margin-left: 220px;
      margin-top: -120px;

      h1 {
        font-size: 4em;
        padding-bottom: 0.1em;
      }
    }

    h2 {
      font-size: 1.8em;
    }
  }
}

</style>
